import { LogicalAndFilter } from '@cubejs-client/core';
import { useMemo } from 'react';

import { HCP_IN_HCO_CUBE_NAME, NO_MATCH_HCP_BK } from '@/api/hco/constants';
import { useHcoFilteredHcpBks } from '@/api/hco/useHcoFilteredHcpBks';

const EMPTY_APPLIED_FILTERS: LogicalAndFilter = { and: [] };

export interface HcoAppliedFilters {
  appliedFilters: LogicalAndFilter;
  isResolving: boolean;
  isError: boolean;
  isResolverFailed: boolean;
}

export const useHcoAppliedFilters = (
  hcoBk: string | undefined,
  includeAllDepartments: boolean,
  hcpBkMember: string = `${HCP_IN_HCO_CUBE_NAME}.hcp_bk`,
): HcoAppliedFilters => {
  const { hcpBks, isResolving, isError, isActive, isTruncated } = useHcoFilteredHcpBks(hcoBk, includeAllDepartments);

  const hasFailed = isActive && (isError || isTruncated);

  const appliedFilters = useMemo<LogicalAndFilter>(() => {
    if (!isActive || hasFailed) return EMPTY_APPLIED_FILTERS;
    const values = hcpBks.length > 0 ? hcpBks : [NO_MATCH_HCP_BK];
    return { and: [{ member: hcpBkMember, operator: 'equals', values }] };
  }, [isActive, hasFailed, hcpBks, hcpBkMember]);

  return {
    appliedFilters,
    isResolving: isResolving || hasFailed,
    isError,
    isResolverFailed: hasFailed,
  };
};
